/* import __COLOCATED_TEMPLATE__ from './mentions-filters.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-management */
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { InboxMentionsStatus } from 'embercom/models/data/inbox/inbox-filters';
import { action } from '@ember/object';
import type IntlService from 'embercom/services/intl';
import type Session from 'embercom/services/session';

interface Arguments {
  selectedMentionsStatus?: InboxMentionsStatus;
  onMentionsStatusChanged?: (status: InboxMentionsStatus) => void;
  selectedLabelPrefix?: number;
}

interface Signature {
  Args: Arguments;
  Element: HTMLDivElement;
}

const REACTION_MENTIONS_OPTIONS = [
  InboxMentionsStatus.Mentions,
  InboxMentionsStatus.Reactions,
  InboxMentionsStatus.Unread,
];

const DEFAULT_OPTIONS = [InboxMentionsStatus.All, InboxMentionsStatus.Unread];

export default class Inbox2LeftNavConversationListMentionsFilters extends Component<Signature> {
  @service declare intl: IntlService;
  @service declare session: Session;

  private get hasReactionMentionsFeature(): boolean {
    return this.session.workspace.canUseFeature('inbox-reaction-mentions');
  }

  private mentionsStatusLabel(option: InboxMentionsStatus): string {
    switch (option) {
      case InboxMentionsStatus.All:
        return this.intl.t('inbox.conversation-filters.mentions-status.all');
      case InboxMentionsStatus.Mentions:
        return this.intl.t('inbox.conversation-filters.mentions-status.mentions');
      case InboxMentionsStatus.Reactions:
        return this.intl.t('inbox.conversation-filters.mentions-status.reactions');
      case InboxMentionsStatus.Unread:
        return this.intl.t('inbox.conversation-filters.mentions-status.unread');
    }
  }

  get items() {
    this.intl.primaryLocale;

    let options = this.hasReactionMentionsFeature ? REACTION_MENTIONS_OPTIONS : DEFAULT_OPTIONS;

    return options.map((option) => {
      return {
        text: this.mentionsStatusLabel(option),
        value: option,
        isSelected: option === this.args.selectedMentionsStatus,
      };
    });
  }

  @action select(value: InboxMentionsStatus) {
    this.args.onMentionsStatusChanged?.(value);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::LeftNav::ConversationList::MentionsFilters': typeof Inbox2LeftNavConversationListMentionsFilters;
    'inbox2/left-nav/conversation-list/mentions-filters': typeof Inbox2LeftNavConversationListMentionsFilters;
  }
}
